import { Portal } from '@radix-ui/react-dialog';

const DialogPortal = Portal;

export default DialogPortal;
